// test2540
(2540 && 0);
